import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios';

// utils
import { DUMMY_CARD_QUESTION } from '../../../utils/dummyData'

export const getMockRounds = createAsyncThunk('/jarvis/mock/rounds', async ({ textMockId }) => {
  const response = await axios.post('/jarvis/mock/rounds', { textMockId })
  return response.data.payload;
})

export const checkIfRoundQnAGeneratedReduxCall = createAsyncThunk('/jarvis/mock/checkIfRoundQnAGenerated', async ({ textMockId }) => {
  const response = await axios.post('/jarvis/mock/checkIfRoundQnAGenerated', { textMockId })
  return response.data.payload;
})

export const getRoundDetail = createAsyncThunk('/jarvis/mock/getRoundDetail', async ({ roundId }) => {
  const response = await axios.post('/jarvis/mock/getRoundDetail', { roundId })
  return response.data.payload;
})

export const getPractices = createAsyncThunk('/jarvis/mock/round/practices', async ({ questionId, question, roundId }) => {
  const response = await axios.post('/jarvis/mock/round/practices', { questionId, question, roundId })
  return response.data.payload;
})

export const uploadAudio = createAsyncThunk('/upload/file', async ({ file }) => {
  var formData = new FormData();
  formData.append("file", file);
  const response = await axios.post('/upload/file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return response.data.payload;
})

export const saveRecording = createAsyncThunk('/jarvis/mock/round/practice/saveRecording', async ({ roundId, questionId, question, recordingUrl }) => {
  const response = await axios.post('/jarvis/mock/round/practice/saveRecording', { roundId, questionId, question, recordingUrl })
  return response.data;
})

export const getAIFeedback = createAsyncThunk('/jarvis/mock/round/practice/getAIFeedback', async ({ practiceId }) => {
  const response = await axios.post('/jarvis/mock/round/practice/getAIFeedback', { practiceId })
  return response.data.payload;
})

export const saveHighlight = createAsyncThunk('/jarvis/mock/round/saveHighlight', async (obj) => {
  const response = await axios.post('/jarvis/mock/round/saveHighlight', obj)
  return { questionInfo: obj, response: response.data };
})

export const getHowToApproach = createAsyncThunk('/jarvis/mock/round/howToApproach', async ({ roundId, questionId, question, type }) => {
  const response = await axios.post('/jarvis/mock/round/howToApproach', { roundId, questionId, question })
  return { questionInfo: { roundId, questionId, type }, response: response.data };
})

export const addNewQuestion = createAsyncThunk('/jarvis/mock/round/addNewQuestion', async ({ roundId, question }) => {
  const response = await axios.post('/jarvis/mock/round/addNewQuestion', { roundId, question })
  return { roundId, response: response.data };
})

export const downloadMockRoundPdf = createAsyncThunk('/jarvis/mock/round/generatePDF', async ({ roundId, fileName }) => {
  const response = await axios.post('/jarvis/mock/round/generatePDF', { roundId }, { responseType: 'blob' })
  return { success: response.status == 200 ? true : false, data: response.data, fileName };
})


export const textMockInterviewSlice = createSlice({
  name: 'textMockInterview',
  initialState: {
    textInterviewDetails: {},
    isTextMockRoundLoading: false,
    startRecheckQnAProgressBar: false,
    recheckQnAGeneration: false,
    roundToBeRechecked: null,
    showAddNewQuestionLoader: false,
    // practices
    showGetPracticesLoader: false,
    practices: [],
    // upload recording 
    uploadedAudioDetails: null,
    feedbackProcessingLoader: false,
    feedbackProcessingText: null,
    // save recording
    newlySavedRecordingDetails: null,
    // aiFeedback
    aiFeedbackReceived: false,
    // highlight
    showHighlightLoader: false,
    // how to approach
    howToApproachContent: '',
    showHowToApproachLoader: false,
    // download round
    showDownloadMockRoundLoader: false
  },
  reducers: {
    updatePracticeCount: (state, action) => {
      const roundId = action.payload.roundId
      const questionId = action.payload.questionId
      let copyTextInterviewDetails = JSON.parse(JSON.stringify(state.textInterviewDetails))
      copyTextInterviewDetails.interviewRounds.forEach(roundEl => {
        if (roundEl.roundId === roundId) {
          if (roundEl.qnas.length > 0) {
            roundEl.qnas.forEach(qnasEl => {
              if (qnasEl._id === questionId) {
                qnasEl.noOfPractices++
              }
            })
          }
        }
      })
      state.textInterviewDetails = copyTextInterviewDetails
    },
    updateTextInterviewDetails: (state, action) => {
      state.textInterviewDetails = action.payload
    },
    setValueByKey: (state, action) => {
      action.payload.forEach(el => {
        const key = el.key
        const value = el.value
        state[key] = value
      })
    }
  },

  extraReducers: {
    [getMockRounds.pending]: state => {
      state.isTextMockRoundLoading = true
      state.startRecheckQnAProgressBar = false
    },
    [getMockRounds.fulfilled]: (state, action) => {
      state.isTextMockRoundLoading = false
      let { interviewRounds, roundAdditionPossible, initialRoundGenerated } = action.payload
      let lastRound = interviewRounds[interviewRounds.length - 1]
      // "initialRoundGenerated" indicates that mock rounds already contains rounds and there will be no calling of "checkIfRoundQnAGeneratedReduxCall"
      // "roundAdditionPossible" tells the new type of structure introduced of generating round by ourself
      // allow new round tab only if the last round has its qnas generated (last condition)
      if (initialRoundGenerated && roundAdditionPossible && interviewRounds.length < 10) { // create round limit is 10
        const dummyRound = { roundName: 'New Round', qnas: [] }
        action.payload.interviewRounds.push(dummyRound)
      }
      state.textInterviewDetails = action.payload
      if (!initialRoundGenerated) {
        state.recheckQnAGeneration = true
        state.startRecheckQnAProgressBar = true
      }
    },
    [getMockRounds.rejected]: state => {
      state.isTextMockRoundLoading = false
      state.startRecheckQnAProgressBar = false
    },
    [getRoundDetail.pending]: state => {

    },
    [getRoundDetail.fulfilled]: (state, action) => {
      const { interviewRound } = action.payload
      const newRoundIdx = state.textInterviewDetails.interviewRounds.findIndex(el => el.roundId === interviewRound[0].roundId)
      let textInterviewDetailsCopy = JSON.parse(JSON.stringify(state.textInterviewDetails))
      if (newRoundIdx === -1) { // if it doesnt exists
        textInterviewDetailsCopy.interviewRounds[textInterviewDetailsCopy.interviewRounds.length - 1] = interviewRound[0]
        if (textInterviewDetailsCopy.interviewRounds.length < 10) textInterviewDetailsCopy.interviewRounds.push({ roundName: 'New Round', qnas: [] })
        state.textInterviewDetails = textInterviewDetailsCopy
      }
      if (interviewRound[0].qnas.length > 0) {
        state.roundToBeRechecked = null

        textInterviewDetailsCopy.interviewRounds[newRoundIdx] = interviewRound[0]

        state.textInterviewDetails = textInterviewDetailsCopy
      }
    },
    [getRoundDetail.rejected]: state => {
      state.roundToBeRechecked = null
    },
    [getPractices.pending]: state => {
      state.showGetPracticesLoader = true
    },
    [getPractices.fulfilled]: (state, action) => {
      const { practices, question, questionId } = action.payload
      state.showGetPracticesLoader = false
      state.practices = practices
    },
    [getPractices.rejected]: state => {
      state.showGetPracticesLoader = false
    },
    [checkIfRoundQnAGeneratedReduxCall.pending]: state => {
      state.startRecheckQnAProgressBar = true
    },
    [checkIfRoundQnAGeneratedReduxCall.fulfilled]: (state, action) => {
      if (action.payload && action.payload.interviewRounds) {
        state.startRecheckQnAProgressBar = false
        state.recheckQnAGeneration = false
        if (action.payload.roundAdditionPossible) { // create round limit is 10
          const dummyRound = { roundName: 'New Round', qnas: [] }
          action.payload.interviewRounds.push(dummyRound)
        }
        state.textInterviewDetails = { ...state.textInterviewDetails, initialRoundGenerated: true, interviewRounds: action.payload.interviewRounds }
      }
    },
    [checkIfRoundQnAGeneratedReduxCall.rejected]: state => {
      state.startRecheckQnAProgressBar = false
      state.recheckQnAGeneration = false
    },
    [uploadAudio.pending]: state => {
      state.feedbackProcessingLoader = true
      state.feedbackProcessingText = 'Uploading Recording...'
    },
    [uploadAudio.fulfilled]: (state, action) => {
      if (action.payload && action.payload.fileUrl) {
        state.uploadedAudioDetails = action.payload
        state.feedbackProcessingText = 'Saving Recording for processing...'
      }
    },
    [uploadAudio.rejected]: state => {
      state.feedbackProcessingLoader = false
      state.feedbackProcessingText = 'Problem in uploading audio please try again after some time.'
    },
    [saveRecording.pending]: state => {
      state.feedbackProcessingLoader = true
      state.feedbackProcessingText = 'Saving Recording...'
    },
    [saveRecording.fulfilled]: (state, action) => {
      if (action.payload.success) {
        state.newlySavedRecordingDetails = action.payload.payload
        state.feedbackProcessingText = 'Processing Recording...'
      } else {
        state.feedbackProcessingText = 'There was some problem in saving recording.Please try again after some time'
      }
    },
    [saveRecording.rejected]: state => {
      state.feedbackProcessingLoader = false
      state.feedbackProcessingText = 'Problem in processing audio please try again after some time.'
    },
    [getAIFeedback.pending]: state => {
      state.feedbackProcessingLoader = true
      state.feedbackProcessingText = 'Getting feedback...'
    },
    [getAIFeedback.fulfilled]: (state, action) => {
      const practice = action.payload.practice
      const { aiFeedback } = practice
      if (aiFeedback) {
        state.feedbackProcessingLoader = false
        state.aiFeedbackReceived = true
        state.practices = [...state.practices, practice]
      }
    },
    [getAIFeedback.rejected]: state => {
      state.feedbackProcessingLoader = false
      state.feedbackProcessingText = 'Problem in getting feedback please try again after some time.'
    },
    [saveHighlight.pending]: state => {
      state.showHighlightLoader = true
    },
    [saveHighlight.fulfilled]: (state, action) => {
      state.showHighlightLoader = false
      const { success } = action.payload.response
      const { questionId,
        answerHighlightArr: newAnswerHighlightArr,
        followUpAnswerHighlightArr: newFollowUpAnswerHighlightArr } = action.payload.questionInfo
      if (success) {
        state.textInterviewDetails = {
          ...state.textInterviewDetails, interviewRounds: state.textInterviewDetails.interviewRounds.map((r) => {
            return {
              ...r, qnas: r.qnas.map((q, k) => {
                if (q._id == questionId) {
                  if (newAnswerHighlightArr) {
                    return {
                      ...q, answerHighlightArr: newAnswerHighlightArr
                    }
                  } else if (newFollowUpAnswerHighlightArr) {
                    return {
                      ...q, followupQnas: [
                        ...q.followupQnas.slice(0, 0),
                        {
                          ...q.followupQnas[0],
                          followUpAnswerHighlightArr: newFollowUpAnswerHighlightArr,
                        },
                        ...q.followupQnas.slice(1),
                      ]
                    }
                  }
                }
                else return { ...q }
              })
            }
          })
        }
      }
    },
    [saveHighlight.rejected]: state => {
      state.showHighlightLoader = false
    },
    [getHowToApproach.pending]: state => {
      state.showHowToApproachLoader = true
    },
    [getHowToApproach.fulfilled]: (state, action) => {
      const { success, payload } = action.payload.response
      const { roundId, questionId, type } = action.payload.questionInfo
      state.showHowToApproachLoader = false
      if (success) {
        state.textInterviewDetails = {
          ...state.textInterviewDetails, interviewRounds: state.textInterviewDetails.interviewRounds.map(round => {
            if (round.roundId === roundId) {
              return {
                ...round, qnas: round.qnas.map(q => {
                  if (q._id === questionId) {
                    if (type === 'main') {
                      return {
                        ...q, howToApproach: payload.howToApproach
                      }
                    } else {
                      return {
                        ...q, followupQnas: [
                          ...q.followupQnas.slice(0, 0),
                          {
                            ...q.followupQnas[0],
                            howToApproach: payload.howToApproach,
                          },
                          ...q.followupQnas.slice(1),
                        ]
                      }
                    }
                  } else {
                    return { ...q }
                  }
                })
              }
            }
            else return { ...round }
          })
        }
        state.howToApproachContent = payload.howToApproach
      }
    },
    [getHowToApproach.rejected]: state => {
      state.showHowToApproachLoader = false
    },
    [addNewQuestion.pending]: (state, action) => {
      state.showAddNewQuestionLoader = true
      const { roundId, question } = action.meta.arg
      const dummyData = JSON.parse(JSON.stringify(DUMMY_CARD_QUESTION))
      dummyData.question = question
      state.textInterviewDetails = {
        ...state.textInterviewDetails, interviewRounds: state.textInterviewDetails.interviewRounds.map(round => {
          if (round.roundId === roundId) {
            return {
              ...round, qnas: [...round.qnas, dummyData]
            }
          }
          else return { ...round }
        })
      }
    },
    [addNewQuestion.fulfilled]: (state, action) => {
      const { response, roundId } = action.payload
      const { success, payload, message } = response
      state.showAddNewQuestionLoader = false
      if (success) {
        const { newQnas } = payload
        state.textInterviewDetails = {
          ...state.textInterviewDetails, interviewRounds: state.textInterviewDetails.interviewRounds.map(round => {
            if (round.roundId === roundId) {
              return {
                ...round, qnas: [...round.qnas.filter((item, idx) => idx !== round.qnas.length - 1), newQnas]
              }
            }
            else return { ...round }
          })
        }
      } else {
        state.textInterviewDetails = {
          ...state.textInterviewDetails, interviewRounds: state.textInterviewDetails.interviewRounds.map(round => {
            if (round.roundId === roundId) {
              return {
                ...round, qnas: [...round.qnas.filter((item, idx) => idx !== round.qnas.length - 1)]
              }
            }
            else return { ...round }
          })
        }
        alert(message)
      }
    },
    [addNewQuestion.rejected]: state => {
      state.showAddNewQuestionLoader = false
    },
    [downloadMockRoundPdf.pending]: state => {
      state.showDownloadMockRoundLoader = true
    },
    [downloadMockRoundPdf.fulfilled]: (state, action) => {
      state.showDownloadMockRoundLoader = false
      const { success, data, fileName } = action.payload
      if (success) {
        const url = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    },
    [downloadMockRoundPdf.rejected]: state => {
      state.showDownloadMockRoundLoader = false
    },
  }
})

export const { setValueByKey, updateTextInterviewDetails, updatePracticeCount } = textMockInterviewSlice.actions

export default textMockInterviewSlice.reducer